import { FormFieldLabel } from '@alison/ui';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import type { ReactNode } from 'react';

export function FieldTooltip({ tooltip }: { tooltip: string | null }): ReactNode {
  if (tooltip === null) return null;
  return (
    <Tooltip title={tooltip}>
      <Box component="span" tabIndex={0} sx={{ display: 'inline-flex' }}>
        <InfoOutlined sx={{ fontSize: 13, color: 'text.disabled' }} />
      </Box>
    </Tooltip>
  );
}

export function FieldHeader({
  label,
  tooltip,
}: {
  label: string;
  tooltip: string | null;
}): ReactNode {
  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
      <FormFieldLabel sx={{ color: 'text.disabled', fontSize: 10 }}>{label}</FormFieldLabel>
      <FieldTooltip tooltip={tooltip} />
    </Stack>
  );
}
